<section>
  <mat-card class="home-list">
    <mat-card-header>
      <mat-card-title class="pl-5">{{ this.name }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <!-- Parte Grupo -->
      <div class="contenedor-principal" *ngIf="rol === 'GRUPO'">
        <div class="pass-container">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <label class="form-label">Nombre</label>
              <input type="text" class="form-control" disabled [value]="name" />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <label class="form-label">Tipo</label>
              <input type="text" class="form-control" disabled [value]="rol" />
            </div>
          </div>
          <div [formGroup]="dataForm" style="padding: 16px">
            <div class="row text-center">
              <div class="col-xl-4 col-lg-3 col-md-2"></div>
              <div class="col-xl-4 col-lg-6 col-md-8 col-sm-12 titulo">
                <h6>Cambiar contraseña</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4 col-lg-3 col-md-2"></div>
              <div
                class="input-group pass1 col-xl-4 col-lg-6 col-md-8 col-sm-12"
              >
                <input
                  class="form-control"
                  [type]="fieldTextType ? 'text' : 'password'"
                  placeholder="Nueva contraseña"
                  formControlName="pass1"
                  [class.is-invalid]="pass1NoValido"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i
                      class="fa"
                      [ngClass]="{
                        'fa-eye-slash': !fieldTextType,
                        'fa-eye': fieldTextType
                      }"
                      (click)="toggleFieldTextType()"
                    ></i>
                  </span>
                </div>
              </div>
              <small *ngIf="pass1NoValido" class="aviso text-left">
                Debe contener al menos 6 caracteres.
              </small>
            </div>

            <div class="row">
              <div class="col-xl-4 col-lg-3 col-md-2"></div>
              <div
                class="input-group pass col-xl-4 col-lg-6 col-md-8 col-sm-12"
              >
                <input
                  class="form-control"
                  [type]="fieldTextType2 ? 'text' : 'password'"
                  placeholder="Repite Contraseña"
                  formControlName="pass2"
                  [class.is-invalid]="pass2NoValido"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i
                      class="fa"
                      [ngClass]="{
                        'fa-eye-slash': !fieldTextType2,
                        'fa-eye': fieldTextType2
                      }"
                      (click)="toggleFieldTextType2()"
                    ></i>
                  </span>
                </div>
              </div>
              <div class="pass col-3">
                <small *ngIf="pass2NoValido" class="aviso text-left">
                  Las contraseñas no son iguales
                </small>
              </div>
            </div>

            <div class="form-group row mt-4">
              <div class="col-xl-5 col-lg-4 col-md-3"></div>
              <div class="input-group col-xl-2 col-lg-4 col-md-6 col-sm-12">
                <button
                  type="submit"
                  (click)="guardar()"
                  [disabled]="!dataForm.valid"
                  class="btn btn-secondary btn-block"
                >
                  Cambiar
                </button>
              </div>
              <div class="col-8"></div>
            </div>
          </div>
        </div>

        <!-- Tabla ----------->
        <div class="table-container ml-2">
          <table mat-table [dataSource]="datasource" class="mat-elevation-z8">
            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef>COLABORADORES</th>
              <td mat-cell *matCellDef="let element">{{ element }}</td>
            </ng-container>

            <ng-container matColumnDef="info">
              <th mat-header-cell *matHeaderCellDef>INFORMACION</th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button (click)="info(element)">
                  <mat-icon>info</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </div>

      <!------------ ADMIN/VENTAS ------------->

      <div class="contenedor-principal" *ngIf="rol != 'GRUPO' && colaborador">
        <div class="pass-container">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <label class="form-label">Nombre</label>
              <input
                type="text"
                class="form-control"
                disabled
                [value]="colaborador.apellido1"
              />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <label class="form-label">CIF</label>
              <input
                type="text"
                class="form-control"
                disabled
                [value]="colaborador.nif"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <label class="form-label">Dirección</label>
              <input
                type="text"
                class="form-control"
                disabled
                [value]="colaborador.direccion"
              />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <label class="form-label">Población</label>
              <input
                type="text"
                class="form-control"
                disabled
                [value]="colaborador.poblacion"
              />
            </div>
          </div>
        </div>
        <div class="table-container ml-2">
          <div [formGroup]="dataForm" style="padding: 16px">
            <div class="row text-center">
              <div class="col-xl-3 col-lg-2 col-md-2"></div>
              <div class="col-xl-6 col-lg-8 col-md-8 col-sm-12 mt-0">
                <h6>Cambiar contraseña</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-2 col-md-2"></div>
              <div
                class="input-group pass1 col-xl-6 col-lg-8 col-md-8 col-sm-12"
              >
                <input
                  class="form-control"
                  [type]="fieldTextType ? 'text' : 'password'"
                  placeholder="Nueva contraseña"
                  formControlName="pass1"
                  [class.is-invalid]="pass1NoValido"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i
                      class="fa"
                      [ngClass]="{
                        'fa-eye-slash': !fieldTextType,
                        'fa-eye': fieldTextType
                      }"
                      (click)="toggleFieldTextType()"
                    ></i>
                  </span>
                </div>
              </div>
              <small *ngIf="pass1NoValido" class="aviso text-left">
                Debe contener al menos 6 caracteres.
              </small>
            </div>

            <div class="row">
              <div class="col-xl-3 col-lg-2 col-md-2"></div>
              <div
                class="input-group pass col-xl-6 col-lg-8 col-md-8 col-sm-12"
              >
                <input
                  class="form-control"
                  [type]="fieldTextType2 ? 'text' : 'password'"
                  placeholder="Repite Contraseña"
                  formControlName="pass2"
                  [class.is-invalid]="pass2NoValido"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i
                      class="fa"
                      [ngClass]="{
                        'fa-eye-slash': !fieldTextType,
                        'fa-eye': fieldTextType
                      }"
                      (click)="toggleFieldTextType2()"
                    ></i>
                  </span>
                </div>
              </div>
              <div class="pass col-3">
                <small *ngIf="pass2NoValido" class="aviso text-left">
                  Las contraseñas no son iguales
                </small>
              </div>
            </div>

            <div class="form-group row mt-4">
              <div class="col-xl-4 col-lg-4 col-md-3"></div>
              <div class="input-group col-xl-4 col-lg-4 col-md-6 col-sm-12">
                <button
                  type="submit"
                  (click)="guardar()"
                  [disabled]="!dataForm.valid"
                  class="btn btn-secondary btn-block"
                >
                  Cambiar
                </button>
              </div>
              <div class="col-8"></div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</section>

<ng-template #myDialog>
  <h2 mat-dialog-title>Información</h2>
  <mat-dialog-content>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12">
        <label class="form-label">Nombre</label>
        <input
          type="text"
          class="form-control"
          disabled
          [value]="colaborador.apellido1"
        />
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <label class="form-label">CIF</label>
        <input
          type="text"
          class="form-control"
          disabled
          [value]="colaborador.nif"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12">
        <label class="form-label">Dirección</label>
        <input
          type="text"
          class="form-control"
          disabled
          [value]="colaborador.direccion"
        />
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <label class="form-label">Población</label>
        <input
          type="text"
          class="form-control"
          disabled
          [value]="colaborador.poblacion"
        />
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button matDialogClose>Cerrar</button>
  </mat-dialog-actions>
</ng-template>

<!--<div *ngIf="spinner" class="spinner swal2-container swal2-center swal2-backdrop-show">
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png">
</div>-->
